// Module
var code = "<div ng-if=\"ready === true\" ng-grid=\"gridOptions\" style=\"height:100%\"></div> ";
// Exports
export default code;